import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63530ec7"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "modal-dialog" }
const _hoisted_2 = { class: "modal-content" }
const _hoisted_3 = {
  key: 0,
  class: "modal-img"
}
const _hoisted_4 = ["src"]
const _hoisted_5 = { class: "modal-header" }
const _hoisted_6 = { class: "modal-title" }
const _hoisted_7 = { class: "modal-body" }
const _hoisted_8 = { class: "modal-footer" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["modal fade", { 'show d-block': $props.visible }]),
    tabindex: "-1",
    onClick: _cache[2] || (_cache[2] = _withModifiers(
//@ts-ignore
(...args) => ($options.closeModal && $options.closeModal(...args)), ["self"]))
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("button", {
          type: "button",
          class: "btn-close",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => ($options.closeModal && $options.closeModal(...args))),
          "aria-label": "Close"
        }),
        ($props.modalImage)
          ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
              _createElementVNode("img", {
                alt: "close",
                src: require(`../../assets/images/${$props.modalImage}`),
                class: "w-auto"
              }, null, 8, _hoisted_4)
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_5, [
          _createElementVNode("div", _hoisted_6, _toDisplayString($props.modalTitle), 1)
        ]),
        _createElementVNode("div", _hoisted_7, _toDisplayString($props.modalContent), 1),
        _createElementVNode("div", _hoisted_8, [
          _createElementVNode("button", {
            type: "button",
            class: "btn text-primary me-sm-3",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => ($options.closeModal && $options.closeModal(...args)))
          }, " CLOSE ")
        ])
      ])
    ])
  ], 2))
}